<template>
  <b-table
    class="assets-table"
    ref="table"
    :data="def.fields"
    :checkable="false"
    :detailed="true"
    :showDetailIcon="true"
    :has-detailed-visible="hasDetailedVisible"
    :opened-detailed="allEnums"
    detail-key="label">
    <template slot-scope="props">
      <b-table-column label="Attribute" class="light">
        <template v-if="props.row.type === 'enum'">
          <a @click="toggle(props.row)">
            {{ props.row.value }}
          </a>
        </template>
        <template v-else>
          {{ props.row.value }}
        </template>
      </b-table-column>
      <b-table-column label="Type">
        {{ props.row.type }}
      </b-table-column>
      <b-table-column label="Class">
        {{ props.row.coding }}
      </b-table-column>
      <b-table-column label="Description">
        {{ props.row.description }}
      </b-table-column>
    </template>

    <template slot="detail" slot-scope="props">
      <span v-for="option in props.row.options" :key="option.label">
        {{ option.value }} = {{ option.label }} &nbsp;&nbsp;&nbsp;&nbsp;
      </span>
    </template>
  </b-table>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FieldDefinitionTable',
  props: {
    def: {
      type: Object,
      required: true,
    },
  },
  computed: {
    allEnums() {
      return _.map(_.filter(this.def.fields, { type: 'enum' }), f => f.label);
    },
  },
  methods: {
    hasDetailedVisible(row) {
      if (row.type === 'enum') {
        return true;
      }
      return false;
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/deep/ .chevron-cell {
  a {
    height: 24px;
    width: 24px;
    display: block;
  }
}

/deep/ tr.detail td {
  padding: 0;

  .detail-container {
    padding: .5rem;
    background: $form-subitem;
  }
}
</style>
